<template>
  <div class="tb-navbar">
    <div class="production-info" :class="{ editing }">
      <div class="production-title-wrapper">
        {{ production.title }}

        <button class="tb-btn tb-btn-text" @click="handleClickUpdateProduction">
          <i class="fas fa-pencil"></i>
        </button>
      </div>
    </div>

    <div class="navbar-tools">
      <tgb-avatar-list :users="connectedUsers" />

      <span class="navbar-separator">|</span>

      <button
        class="tb-btn tb-btn-contained medium-em"
        name="Manage Output"
        @click="handleClickManageScreens"
      >
        <span class="icon icon-desktop margin-right-xxs"></span>
        <span>Outputs</span>
      </button>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';

import TgbAvatarList from '../../../components/ui/user-avatar/TgbAvatarList.vue';

dayjs.extend(duration);
dayjs.extend(relativeTime);

export default {
  components: {
    TgbAvatarList,
  },

  data() {
    return {
      // Storing current date in state so we can create a ticker
      now: dayjs(),
      interval: null,
      editing: false,
    };
  },

  mounted() {
    this.$socket.emit('getClients', {
      production_id: this.production?._id,
    });

    this.interval = setInterval(() => {
      this.now = dayjs();
    }, 30e3);
  },

  destroyed() {
    clearInterval(this.interval);
  },

  methods: {
    openEditing() {
      this.editing = true;

      this.$nextTick(() => {
        this.$refs.title.focus();
      });
    },

    handleClickManageScreens() {
      this.$store.dispatch('toggleScreensModal');
    },
    handleClickUpdateProduction() {
      this.$store.dispatch('toggleUpdateProductionModal');
    },
  },
  computed: {
    production() {
      return this.$store.state.production.production;
    },

    connectedUsers() {
      // this whole state management socket thing for clients needs to be refactored
      // which was a little big for this bug fix ticket, so I left in this dumb loop thing
      // and just made it get loop in all, so I could filter out dupes in the component
      const clients = this.$store.state.clients.userOrder;
      const connectedUsers = [];

      for (let i = 0; i < clients.length; i += 1) {
        if (clients[i]) {
          connectedUsers.push(this.$store.state.clients.connectedUsers[clients[i]]);
        }
      }

      return connectedUsers;
    },
  },
};
</script>
